import styles from './styles.scss'

export {default} from './template'
export {styles as classNames}

const LARGE_HEIGHT = 320

export const getContainerClassNames = ({
  height
}: {
  height: number
}): [string, boolean][] => [[styles.largeHeight, height >= LARGE_HEIGHT]]
